import { render, staticRenderFns } from "./HeroPositionGrid.vue?vue&type=template&id=0d6fe38b&scoped=true&"
import script from "./HeroPositionGrid.vue?vue&type=script&lang=js&"
export * from "./HeroPositionGrid.vue?vue&type=script&lang=js&"
import style0 from "./HeroPositionGrid.vue?vue&type=style&index=0&id=0d6fe38b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6fe38b",
  null
  
)

export default component.exports